import React, { useState, useEffect, useRef } from 'react';
import FormField from './FormField';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { resizeImage } from '../utils/imageOptimizer';

const HONDURAS_GEOGRAPHY = {
  'Atlántida': ['La Ceiba', 'Tela', 'Jutiapa', 'La Masica', 'San Francisco', 'El Porvenir', 'Esparta', 'Arizona'],
  'Choluteca': ['Choluteca', 'Apacilagua', 'Concepción de María', 'Duyure', 'El Corpus', 'El Triunfo', 'Marcovia', 'Morolica', 'Namasigüe', 'Orocuina', 'Pespire', 'San Antonio de Flores', 'San Isidro', 'San José', 'Santa Ana de Yusguare'],
  'Colón': ['Trujillo', 'Balfate', 'Iriona', 'Limón', 'Sabá', 'Santa Fe', 'Santa Rosa de Aguán', 'Sonaguera', 'Tocoa', 'Bonito Oriental'],
  'Comayagua': ['Comayagua', 'Ajuterique', 'El Rosario', 'Esquías', 'Humuya', 'La Libertad', 'Lamaní', 'La Trinidad', 'Lejamaní', 'Meámbar', 'Minas de Oro', 'Ojos de Agua', 'San Jerónimo', 'San José de Comayagua', 'San Luis', 'San Sebastián', 'Siguatepeque', 'Villa de San Antonio', 'Las Lajas', 'Taulabé'],
  'Copán': ['Santa Rosa de Copán', 'Cabañas', 'Concepción', 'Copán Ruinas', 'Corquín', 'Cucuyagua', 'Dolores', 'Dulce Nombre', 'El Paraíso', 'Florida', 'La Jigua', 'La Unión', 'Nueva Arcadia', 'San Agustín', 'San Antonio', 'San Jerónimo', 'San Juan de Opoa', 'San Nicolás', 'San Pedro', 'Santa Rita', 'Trinidad de Copán'],
  'Cortés': ['San Pedro Sula', 'Choloma', 'Omoa', 'Pimienta', 'Potrerillos', 'Puerto Cortés', 'San Antonio de Cortés', 'San Francisco de Yojoa', 'San Manuel', 'San Manuel', 'Santa Cruz de Yojoa', 'Villanueva', 'La Lima'],
  'El Paraíso': ['Yuscarán', 'Alauca', 'Danlí', 'El Paraíso', 'Güinope', 'Jacaleapa', 'Liure', 'Morocelí', 'Oropolí', 'Potrerillos', 'San Antonio de Flores', 'San Lucas', 'San Matías', 'Soledad', 'Teupasenti', 'Texiguat', 'Vado Ancho', 'Yauyupe', 'Trojes'],
  'Francisco Morazán': ['Tegucigalpa (Distrito Central)', 'Cedros', 'Curarén', 'El Porvenir', 'Guaimaca', 'La Libertad', 'La Venta', 'Lepaterique', 'Maraita', 'Marale', 'Nueva Armenia', 'Ojojona', 'Oriaca', 'Reitoca', 'Sabanagrande', 'San Antonio de Oriente', 'San Buenaventura', 'San Ignacio', 'San Juan de Flores', 'San Miguelito', 'Santa Ana', 'Santa Lucía', 'Talanga', 'Tatumbla', 'Valle de Ángeles', 'Villa de San Francisco', 'Vallecillo'],
  'Gracias a Dios': ['Puerto Lempira', 'Brus Laguna', 'Ahuas', 'Juan Francisco Bulnes', 'Villeda Morales', 'Wampusirpi'],
  'Intibucá': ['La Esperanza', 'Camasca', 'Colomoncagua', 'Concepción', 'Dolores', 'Intibucá', 'Jesús de Otoro', 'Magdalena', 'Masaguane', 'San Antonio', 'San Isidro', 'San Juan', 'San Marcos de Sierra', 'San Miguelito', 'Yamaranguila', 'San Francisco de Opalaca'],
  'Islas de la Bahía': ['Roatán', 'Guanaja', 'José Santos Guardiola', 'Utila'],
  'La Paz': ['La Paz', 'Aguanqueterique', 'Cabañas', 'Cane', 'Chinacla', 'Guajiquiro', 'Lauterique', 'Marcala', 'Mercedes de Oriente', 'Opatoro', 'San Antonio del Norte', 'San José', 'San Juan', 'San Pedro de Tutule', 'Santa Ana', 'Santa Elena', 'Santa María', 'Santiago de Puringla', 'Yarula'],
  'Lempira': ['Gracias', 'Belén', 'Candelaria', 'Cololaca', 'Erandique', 'Gualcince', 'Guarita', 'La Campa', 'La Iguala', 'Las Flores', 'La Unión', 'La Virtud', 'Lepaera', 'Mapulaca', 'Piraera', 'San Andrés', 'San Francisco', 'San Juan Guarita', 'San Manuel Colohete', 'San Marcos de Caiquín', 'San Rafael', 'San Sebastián', 'Santa Cruz', 'Talgua', 'Tambla', 'Tomalá', 'Valladolid', 'Virginia'],
  'Ocotepeque': ['Ocotepeque', 'Belén Gualcho', 'Concepción', 'Dolores Merendón', 'Fraternidad', 'La Encarnación', 'La Labor', 'Lucerna', 'Mercedes', 'San Fernando', 'San Francisco del Valle', 'San Jorge', 'San Marcos', 'Santa Fe', 'Sinuapa', 'Sensenti'],
  'Olancho': ['Juticalpa', 'Campamento', 'Catacamas', 'Concordia', 'Dulce Nombre de Culmí', 'El Rosario', 'Esquipulas del Norte', 'Gualaco', 'Guarizama', 'Guata', 'Guayape', 'Jano', 'La Unión', 'Mangulile', 'Manto', 'Salamá', 'San Esteban', 'San Francisco de Becerra', 'San Francisco de la Paz', 'Santa María del Real', 'Silca', 'Yocón', 'Patuca'],
  'Santa Bárbara': ['Santa Bárbara', 'Arada', 'Atima', 'Azacualpa', 'Ceguaca', 'Concepción del Norte', 'Concepción del Sur', 'Chinda', 'El Níspero', 'Gualala', 'Ilama', 'Macuelizo', 'Naranjito', 'Nueva Celilac', 'Petoa', 'Protección', 'Quimistán', 'San Francisco de Ojuera', 'San José de las Colinas', 'San Luis', 'San Marcos', 'San Nicolás', 'San Pedro Zacapa', 'Santa Rita', 'San Vicente Centenario', 'Trinidad', 'Las Vegas', 'Nueva Frontera'],
  'Valle': ['Nacaome', 'Alianza', 'Amapala', 'Aramecina', 'Caridad', 'Goascorán', 'Langue', 'San Francisco de Coray', 'San Lorenzo'],
  'Yoro': ['Yoro', 'Arenal', 'El Negrito', 'El Progreso', 'Jocón', 'Morazán', 'Olanchito', 'Santa Rita', 'Sulaco', 'Victoria', 'Yorito']
};

const INITIAL_STATE = {
  propertyType: '',
  operation: '',
  address: '',
  city: '',
  state: '',
  price: '',
  currency: 'HNL',
  bedrooms: '',
  bathrooms: '',
  area: '',
  areaUnit: 'm²',
  parking: '',
  amenities: '',
  images: [],
  coverIndex: 0,
  customFlyer: null,
  agentName: '',
  agentPhone: '',
  agentEmail: ''
};

const PropertyForm = ({ onSubmit, initialData = null }) => {
  const [formData, setFormData] = useState(INITIAL_STATE);
  const [availableCities, setAvailableCities] = useState([]);
  const [isProcessingImages, setIsProcessingImages] = useState(false);
  const fileInputRef = useRef(null);
  const flyerInputRef = useRef(null);

  useEffect(() => {
    if (initialData) {
      setFormData({
        propertyType: initialData.property_type || '',
        operation: initialData.operation || '',
        address: initialData.address || '',
        city: initialData.city || '',
        state: initialData.state || '',
        price: initialData.price || '',
        currency: initialData.currency || 'HNL',
        bedrooms: initialData.bedrooms || '',
        bathrooms: initialData.bathrooms || '',
        area: initialData.area || '',
        areaUnit: initialData.area_unit || (initialData.property_type === 'Terreno' ? 'v²' : 'm²'),
        parking: initialData.parking || '',
        amenities: initialData.amenities || '',
        images: initialData.images || [],
        coverIndex: initialData.cover_index || 0,
        customFlyer: initialData.custom_flyer || null,
        agentName: initialData.agent_name || '',
        agentPhone: initialData.agent_phone || '',
        agentEmail: initialData.agent_email || ''
      });
    }
  }, [initialData]);

  useEffect(() => {
    if (formData.state) {
      setAvailableCities(HONDURAS_GEOGRAPHY[formData.state] || []);
    }
  }, [formData.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    const remainingSlots = 10 - formData.images.length;
    
    if (remainingSlots <= 0) {
      alert("Ya has alcanzado el límite de 10 fotos.");
      return;
    }

    const filesToProcess = files.slice(0, remainingSlots);

    setIsProcessingImages(true);
    for (const file of filesToProcess) {
      const reader = new FileReader();
      const base64 = await new Promise((resolve) => {
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      const optimizedBase64 = await resizeImage(base64);
      setFormData(prev => ({
        ...prev,
        images: [...prev.images, { id: Math.random().toString(36), src: optimizedBase64 }]
      }));
    }
    setIsProcessingImages(false);
    
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleFlyerChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setIsProcessingImages(true);
    const reader = new FileReader();
    const base64 = await new Promise((resolve) => {
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });
    const optimizedBase64 = await resizeImage(base64, 1200, 1500);
    setFormData(prev => ({ ...prev, customFlyer: optimizedBase64 }));
    setIsProcessingImages(false);
  };

  const removeImage = (index) => {
    setFormData(prev => {
      const newImages = prev.images.filter((_, i) => i !== index);
      let newCoverIndex = prev.coverIndex;
      if (prev.coverIndex === index) newCoverIndex = 0;
      else if (prev.coverIndex > index) newCoverIndex--;
      
      return { ...prev, images: newImages, coverIndex: newCoverIndex };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.images.length === 0) return alert("Sube al menos una foto de la galería de la propiedad.");
    onSubmit(formData);
  };

  return (
    <motion.form 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      onSubmit={handleSubmit} 
      className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden"
    >
      <div className="bg-emerald-50/50 px-6 py-4 border-b border-emerald-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <SafeIcon icon={initialData ? FiIcons.FiEdit : FiIcons.FiPlus} className="text-emerald-700" />
          <h2 className="text-lg font-semibold text-emerald-900">
            {initialData ? 'Editar Propiedad' : 'Cargar Nueva Propiedad'}
          </h2>
        </div>
      </div>

      <div className="p-6 space-y-8">
        {/* SECCIÓN PORTADA CANVA */}
        <div className="bg-amber-50 p-6 rounded-2xl border border-amber-100 relative overflow-hidden">
          <div className="absolute top-0 right-0 p-12 bg-amber-100/50 rounded-bl-[100px] -z-10"></div>
          <div className="flex items-start gap-4">
            <div className="bg-white p-3 rounded-xl shadow-sm border border-amber-100">
              <SafeIcon icon={FiIcons.FiImage} className="text-amber-600 text-xl" />
            </div>
            <div className="flex-grow">
              <h3 className="text-sm font-bold text-amber-900 uppercase tracking-tight">Portada de Venta (Flyer Canva)</h3>
              <p className="text-xs text-amber-700 mb-4 max-w-lg">Carga aquí la imagen que diseñaste en Canva. Esta será la portada principal que se exportará en el Kit de Redes Sociales.</p>
              
              {formData.customFlyer ? (
                <div className="relative w-32 aspect-[4/5] rounded-lg overflow-hidden border-2 border-amber-300 shadow-md group">
                  <img src={formData.customFlyer} className="w-full h-full object-cover" alt="Flyer Personalizado" />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                    <button 
                      type="button" 
                      onClick={() => setFormData(p => ({ ...p, customFlyer: null }))}
                      className="p-2 bg-red-500 text-white rounded-full shadow-lg transform scale-90 group-hover:scale-100 transition-all"
                    >
                      <SafeIcon icon={FiIcons.FiTrash2} />
                    </button>
                  </div>
                </div>
              ) : (
                <button 
                  type="button"
                  onClick={() => flyerInputRef.current?.click()}
                  className="px-4 py-2 bg-white border border-amber-200 text-amber-800 text-xs font-bold rounded-lg hover:bg-amber-100 transition-colors shadow-sm flex items-center gap-2"
                >
                  <SafeIcon icon={FiIcons.FiUploadCloud} /> SUBIR FLYER DISEÑADO
                </button>
              )}
            </div>
          </div>
          <input type="file" ref={flyerInputRef} onChange={handleFlyerChange} accept="image/*" className="hidden" />
        </div>

        {/* Galería de Fotos */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-bold text-gray-700 uppercase flex items-center gap-2">
              <SafeIcon icon={FiIcons.FiCamera} /> Fotos de la Propiedad ({formData.images.length}/10)
            </h3>
            {formData.images.length < 10 && (
              <button 
                type="button" 
                onClick={() => fileInputRef.current?.click()}
                className="text-xs font-bold text-emerald-700 bg-emerald-50 hover:bg-emerald-100 px-4 py-2 rounded-lg border border-emerald-200 transition-colors shadow-sm flex items-center gap-2"
              >
                <SafeIcon icon={FiIcons.FiPlus} /> Añadir Fotos
              </button>
            )}
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
            {formData.images.map((img, index) => (
              <div 
                key={img.id} 
                className={`group relative aspect-square rounded-xl overflow-hidden border-2 transition-all ${
                  formData.coverIndex === index 
                    ? 'border-emerald-500 ring-4 ring-emerald-500/20' 
                    : 'border-gray-200 hover:border-emerald-300'
                }`}
              >
                <img src={img.src} className="w-full h-full object-cover" alt={`Propiedad ${index + 1}`} />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity" />

                <button 
                  type="button" 
                  onClick={(e) => { e.stopPropagation(); removeImage(index); }}
                  className="absolute top-2 right-2 p-2 bg-red-500 hover:bg-red-600 text-white rounded-lg opacity-0 group-hover:opacity-100 transition-all transform scale-90 group-hover:scale-100 shadow-lg z-10"
                >
                  <SafeIcon icon={FiIcons.FiTrash2} />
                </button>

                <button 
                  type="button" 
                  onClick={(e) => { e.stopPropagation(); setFormData(p => ({...p, coverIndex: index})); }}
                  className={`absolute top-2 left-2 p-2 rounded-lg transition-all shadow-lg z-10 ${
                    formData.coverIndex === index 
                      ? 'bg-emerald-500 text-white opacity-100' 
                      : 'bg-white text-gray-700 opacity-0 group-hover:opacity-100 transform scale-90 group-hover:scale-100 hover:bg-emerald-50'
                  }`}
                >
                  <SafeIcon icon={FiIcons.FiStar} className={formData.coverIndex === index ? 'fill-current' : ''} />
                </button>

                {formData.coverIndex === index && (
                  <div className="absolute bottom-0 left-0 right-0 bg-emerald-500/95 text-white text-[9px] font-black text-center py-1.5 uppercase tracking-widest backdrop-blur-sm">
                    FOTO INICIAL REEL
                  </div>
                )}
              </div>
            ))}
            
            {formData.images.length < 10 && (
              <button
                type="button"
                onClick={() => fileInputRef.current?.click()}
                className="aspect-square rounded-xl border-2 border-dashed border-gray-300 hover:border-emerald-400 hover:bg-emerald-50 transition-colors flex flex-col items-center justify-center gap-2 text-gray-400 hover:text-emerald-600"
              >
                <SafeIcon icon={FiIcons.FiPlus} className="text-2xl" />
                <span className="text-xs font-bold">Añadir Foto</span>
              </button>
            )}
          </div>
          <input type="file" ref={fileInputRef} onChange={handleFileChange} multiple accept="image/*" className="hidden" />
          {isProcessingImages && <p className="text-xs text-emerald-600 animate-pulse font-bold mt-2">Optimizando imágenes...</p>}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <FormField label="Tipo" name="propertyType" type="select" value={formData.propertyType} onChange={handleChange} options={['Casa', 'Departamento', 'Terreno', 'Local', 'Oficina']} />
          <FormField label="Operación" name="operation" type="select" value={formData.operation} onChange={handleChange} options={['Venta', 'Renta']} />
          <FormField label="Moneda" name="currency" type="select" value={formData.currency} onChange={handleChange} options={['HNL', 'USD']} />
          <FormField label="Precio" name="price" type="number" value={formData.price} onChange={handleChange} placeholder="Ej. 2500000" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <FormField label="Departamento" name="state" type="select" value={formData.state} onChange={handleChange} options={Object.keys(HONDURAS_GEOGRAPHY)} />
          <FormField label="Ciudad" name="city" type="select" value={formData.city} onChange={handleChange} options={availableCities} />
          <FormField label="Dirección/Colonia" name="address" value={formData.address} onChange={handleChange} />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <FormField label="Habitaciones" name="bedrooms" type="number" value={formData.bedrooms} onChange={handleChange} />
          <FormField label="Baños" name="bathrooms" type="number" value={formData.bathrooms} onChange={handleChange} />
          <FormField label="Parqueos" name="parking" type="number" value={formData.parking} onChange={handleChange} />
          
          {/* Selector de Unidad de Área Restaurado */}
          <div className="flex gap-2">
            <div className="flex-grow">
              <FormField label="Área" name="area" type="number" value={formData.area} onChange={handleChange} />
            </div>
            <div className="w-24">
              <FormField label="Unidad" name="areaUnit" type="select" value={formData.areaUnit} onChange={handleChange} options={['m²', 'v²']} />
            </div>
          </div>
        </div>

        <FormField label="Extras/Amenidades" name="amenities" type="textarea" value={formData.amenities} onChange={handleChange} placeholder="Piscina, seguridad, etc." />

        <div className="bg-emerald-50/30 -mx-6 px-6 py-6 border-t border-emerald-100 grid grid-cols-1 md:grid-cols-3 gap-4">
          <FormField label="Nombre Asesor" name="agentName" value={formData.agentName} onChange={handleChange} />
          <FormField label="WhatsApp" name="agentPhone" value={formData.agentPhone} onChange={handleChange} />
          <FormField label="Email" name="agentEmail" value={formData.agentEmail} onChange={handleChange} />
        </div>
      </div>

      <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end">
        <button type="submit" className="px-8 py-3 bg-emerald-700 text-white font-bold rounded-xl shadow-lg hover:bg-emerald-800 transition-all flex items-center gap-2">
          <SafeIcon icon={FiIcons.FiSave} /> {initialData ? 'GUARDAR CAMBIOS' : 'GENERAR KIT DE VENTA'}
        </button>
      </div>
    </motion.form>
  );
};

export default PropertyForm;